import { fetchSymbol, clearSymbol } from '../../etc/currency';
import {defineStore} from "pinia";

export const useCurrencyStore = defineStore('currency', {
    state: () => ({
        symbol: ''
    }),
    actions: {
        setSymbol(value) {
            this.symbol = value;
        },
        fetch() {
            fetchSymbol();
        },
        clear() {
            clearSymbol();
        }
    }
});
